import { render, staticRenderFns } from "./AddMunicipioPage.vue?vue&type=template&id=cb9b36e6"
import script from "./AddMunicipioPage.vue?vue&type=script&lang=js"
export * from "./AddMunicipioPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports